import { useEffect, useMemo } from 'react'
import axios from 'axios'
import { Amplify } from 'aws-amplify'
import { fetchAuthSession, fetchUserAttributes } from 'aws-amplify/auth'
import { withAuthenticator } from '@aws-amplify/ui-react'
import * as Sentry from '@sentry/react'
import './config/sentry'

import { COGNITO } from './config/aws'

import { BASE_API_URL } from './utils/Enum'

import { ErrorBoundary } from 'react-error-boundary'
import ErrorFallback from './components/error-fallback/ErrorFallback'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import useIdle from './hooks/useIdleTimer'
import { ROUTES } from './Routes'
import Header from './components/header/Header'
import Footer from './components/footer/Footer'

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: COGNITO.USER_POOL_ID,
      userPoolClientId: COGNITO.APP_CLIENT_ID,
    },
  },
})


const App = ({ signOut }) => {
  const request = useMemo(
    () => {
      const instance = axios.create({ baseURL: BASE_API_URL })
      // Per request, so a token Amplify has refreshed reaches the API.
      instance.interceptors.request.use(async (config) => {
        const { tokens } = await fetchAuthSession()
        config.headers.Authorization = tokens?.idToken?.toString()
        return config
      })
      return instance
    },
    []
  )

  useEffect(
    () => {
      fetchUserAttributes()
        .then(({ email }) => Sentry.setUser({ email }))
        .catch((error) => Sentry.captureException(error))
    },
    []
  )

  const { isIdle } = useIdle({ idleTime: 30 })

  if (isIdle) signOut()

  return (
    <div className='container'>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Header
          signOut={signOut}
        />
        <main id='main' className='main'>
          {ROUTES({ request })}
          <ToastContainer />
        </main>
        <Footer />
      </ErrorBoundary>
    </div>
  )
}

export default withAuthenticator(App, { hideSignUp: true })
